import useAdBlockStore from "store/AdBlockStore";
import { Button, Popconfirm, Skeleton, Tooltip } from "antd";
import { productStringEval } from "utils";
import { useDataStore } from "store/DataStore";
import { FaCheckCircle, FaClone, FaExclamation, FaTrash, FaRobot } from "react-icons/fa";
import { BsClockFill, BsMagic } from "react-icons/bs";
import useKeypress from "react-use-keypress";

const ProductPreview = () => {
  const isLoading = useAdBlockStore((state) => state.isLoading);
  const isApproving = useAdBlockStore(state => state.isApproving);
  const isRejecting = useAdBlockStore(state => state.isRejecting);
  const isDNELoading = useAdBlockStore(state => state.isDNELoading);
  const products = useAdBlockStore((state) => state.products);
  const productSizes = useDataStore((state) => state.productSizes);
  const currentProduct = useAdBlockStore((state) => state.currentProduct);
  const setCurrentProduct = useAdBlockStore((state) => state.setCurrentProduct);
  const removeProduct = useAdBlockStore((state) => state.removeProduct);
  const removeProductByID = useAdBlockStore((state) => state.removeProductByID);
  const existingProductInfo = useAdBlockStore((state) => state.existingProductInfo);

  useKeypress([']'], (event) => {
    event.preventDefault();
    if (currentProduct?.index === products.length - 1) {
      setCurrentProduct(products[0]);
      return;
    }
    const nextIndex = (currentProduct?.index || 0) + 1;
    const nextProduct = products.find((p) => p.index === nextIndex);
    if (nextProduct) {
      setCurrentProduct(nextProduct);
    }
  });

  useKeypress(['['], (event) => {
    event.preventDefault();
    if (currentProduct?.index === 0) {
      setCurrentProduct(products[products.length - 1]);
      return;
    }
    const prevIndex = (currentProduct?.index || 0) - 1;
    const prevProduct = products.find((p) => p.index === prevIndex);
    if (prevProduct) {
      setCurrentProduct(prevProduct);
    }
  });

  // Clone products
  useKeypress(["o", "O"], (event) => {
    // Ignore OS key-repeat: holding Alt+O must not clone a row per repeat.
    if (event.repeat) return;
    if (event.altKey) {
      if (!(isLoading || isApproving || isRejecting || isDNELoading)) {
        if (products.length > 0) {
          useAdBlockStore.getState().cloneProduct(currentProduct.id);
        }
      }
    }
  });

  if (isLoading) {
    return (
      <>
        {[...Array(3)].map((_, i) => (
          <Skeleton.Input key={i} active block />
        ))}
      </>
    );
  }
  return (
    <>
      {products.map((product, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "6px 10px",
            cursor: "pointer",
            borderRadius: "4px",
            border: `2px solid ${currentProduct?.index === product.index ? "#1890ff" : "var(--gray-color)"}`,
            backgroundColor: currentProduct?.index === product.index ? "var(--items-color)" : "transparent",
            fontSize: "15px",
            fontWeight: "500",
            letterSpacing: "0.4px",
            transition: "all 0.2s ease",
          }}
        >
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
            width: "90%",
          }}
            onClick={() => useAdBlockStore.setState({ currentProduct: product })}
          >
            <Button type="link" size="small" style={{ padding: 0 }} color="red">
              {product.isValid ?
                <FaCheckCircle color="var(--success-color)" />
                : <FaExclamation color="var(--error-color)" />}
            </Button>
            {productStringEval(product, productSizes, index)}
          </div>
          <div style={{
            display: "flex",
            gap: "8px",
            color: "rgba(255, 255, 255, 0.6)",
            fontSize: "11px",
          }}>
            {product.open_ai &&
              <Button type="link" size="small" style={{ padding: 0 }} color="red">
                <BsMagic color="var(--warning-yellow)" />
              </Button>
            }
            {product.addison_agent &&
              <Button type="link" size="small" style={{ padding: 0 }} color="red">
                <Tooltip title="Addison Agent suggestion">
                  <FaRobot color="var(--info-color)" />
                </Tooltip>
              </Button>
            }
            {product.existingProduct &&
              <Button
                type="link"
                size="small"
                style={{ padding: 0 }}
                color="red"
                onClick={() =>
                  window.open(`/edit/${existingProductInfo?.adblock_info?.circular_uuid}/${existingProductInfo?.adblock_info?.page_uuid}/${existingProductInfo?.adblock_info?.adblock_uuid}`)}>
                <Tooltip title="Existing Product">
                  <BsClockFill color="var(--misc-purple)" />
                </Tooltip>
              </Button>
            }
            <Button type="link" size="small" style={{ padding: 0 }} color="red" onClick={() => useAdBlockStore.getState().cloneProductByIndex(product.index)}>
              <Tooltip title="Clone Product">
                <FaClone color="var(--white)" />
              </Tooltip>
            </Button>
            {product.id != null ? (
              <Popconfirm
                title="Delete Product"
                description="Are you sure to delete this product?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => removeProductByID(product.id)}
              >
                <Button type="link" size="small" style={{ padding: 0 }}>
                  <Tooltip title="Delete Product">
                    <FaTrash color="var(--danger-pink)" />
                  </Tooltip>
                </Button>
              </Popconfirm>
            ) : (
              <Button
                type="link"
                size="small"
                style={{ padding: 0 }}
                onClick={() => removeProduct(product)}
              >
                <Tooltip title="Delete Product">
                  <FaTrash color="var(--danger-pink)" />
                </Tooltip>
              </Button>
            )}
          </div>
        </div>
      ))}
    </>
  )
};

export default ProductPreview;